import { useTenant } from "../../../../hooks/useTenant";
import { usePerformanceFilters } from "./usePerformanceFilters";
import { usePerformanceData } from "./usePerformanceData";

/**
 * usePerformance (Orquestrador)
 * Junta os filtros visuais com a camada de carregamento e recálculo de dados.
 */
export const usePerformance = () => {
    const { idTenant } = useTenant();

    const {
        selectedPeriod,
        setSelectedPeriod,
        selectedGroup,
        setSelectedGroup,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        periodOptions
    } = usePerformanceFilters();

    const {
        snapshots,
        excludedSnapshots,
        loading,
        recalculating,
        isCurrentPeriod,
        handleRecalculate
    } = usePerformanceData({ idTenant, selectedPeriod, startDate, endDate });

    // ─── Dados filtrados ───
    const filteredSnapshots = selectedGroup === "all"
        ? snapshots
        : snapshots.filter(s => s.employeeRole === selectedGroup);

    const filteredExcluded = selectedGroup === "all"
        ? excludedSnapshots
        : excludedSnapshots.filter(s => s.employeeRole === selectedGroup);

    return {
        snapshots: filteredSnapshots,
        excludedSnapshots: filteredExcluded,
        allSnapshots: snapshots,
        loading,
        recalculating,
        isCurrentPeriod,
        selectedPeriod,
        selectedGroup,
        startDate,
        endDate,
        periodOptions,
        setSelectedPeriod,
        setSelectedGroup,
        setStartDate,
        setEndDate,
        handleRecalculate,
    };
};
